import axios from '../../axios'

/**
 * 1.0.1 获取体测项目列表
 * @param agencyId  项目所属机构id, 如果为-1则查询国家统一测试项目
 * @returns {Promise | Promise<unknown>}
 */
export const list = agencyId => {
  return axios({
    url: '/clubExamines/examinItem/list/' + agencyId,
    method: 'GET'
  })
}

/**
 * 1.0.2 添加项目
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const add = data => {
  return axios({
    url: '/clubExamines/examinItem/add',
    method: 'POST',
    data
  })
}

/**
 * 1.0.3 修改项目
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const modify = data => {
  return axios({
    url: '/clubExamines/examinItem/update',
    method: 'PUT',
    data
  })
}

/**
 * 1.0.4 删除项目
 * @param id
 * @param isDelete
 * @returns {Promise | Promise<unknown>}
 */
export const delOrBack = (id, isDelete) => {
  return axios({
    url: '/clubExamines/examinItem/delOrBack/' + id + '/' + isDelete,
    method: 'PUT'
  })
}

/**
 * 1.0.5 查询机构的测试项目，含国家统一测试项目和自己的特色项目
 * @param agencyId
 * @returns {Promise | Promise<unknown>}
 */
export const listByAgency = agencyId => {
  return axios({
    url: '/clubExamines/examinItem/listByAgency/' + agencyId,
    method: 'GET'
  })
}

/**
 * 1.0.6 查询学生匹配的测试项目
 * @param agencyId    学生所在机构id
 * @param studentId   学生id
 * @param birthday    学生生日
 */
export const listByStudent = (agencyId, studentId, birthday, sex) => {
  return axios({
    url: '/clubExamines/examinItem/listByStudent/' + agencyId + '/' + studentId + '/' + birthday + '/' + sex,
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/examines/clubExamines.js